"use client";
import { cn } from "@scott/ui/utils/cn";
import type { BrandConfig } from "@ui-d2c/types";
import type * as React from "react";
import { Body } from "../body";

export interface copyrightsProps extends React.HTMLAttributes<HTMLDivElement> {
  brand: BrandConfig;
  description?: string;
}

const Copyright = ({ brand, className, description }: copyrightsProps) => (
  <div
    className={cn(
      "container flex flex-col items-center px-4 py-6",
      className,
      brand.isDolomite && "bg-brand-medium"
    )}
  >
    <div className="flex font-paragraph">
      <Body
        className={cn("text-center text-followus-normal", className)}
        size="xs"
      >
        {description}
      </Body>
    </div>
  </div>
);

Copyright.displayName = "Copyright";

export { Copyright };
